export default __webpack_public_path__ + "static/media/_DSC0532.d70a7e4e.JPG";